import BaseBlockContent from '@sanity/block-content-to-react';
import React from 'react';
import PropTypes from 'prop-types';

import blockSerializers from '../../utils/blockSerializers';

const BlockContent = ({ blocks, imageOptions, ...rest }) => (
  <BaseBlockContent
    blocks={blocks}
    serializers={blockSerializers}
    imageOptions={imageOptions}
    {...rest}
  />
);

BlockContent.propTypes = {
  blocks: PropTypes.arrayOf(
    PropTypes.shape({
      _type: PropTypes.string.isRequired,
    })
  ),
  imageOptions: PropTypes.shape({
    maxWidth: PropTypes.number,
  }),
};

BlockContent.defaultProps = {
  blocks: [],
  imageOptions: {
    maxWidth: 960,
    sizes: '100vw',
  },
};

export default BlockContent;
